var map = {
	"./portfolio-1.jpg": 66255,
	"./portfolio-2.jpg": 80118,
	"./portfolio-3.jpg": 50304,
	"./portfolio-4.jpg": 65982,
	"./portfolio-5.jpg": 89874,
	"./portfolio-6.jpg": 83670,
	"./portfolio-7.jpg": 8626,
	"./portfolio-8.jpg": 60128,
	"./portfolio-9.jpg": 711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9750;